import { Component, inject, input } from '@angular/core';
import { AsyncPipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { I18nModule, TranslationService } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { MakeAPaymentService } from '../make-a-payment.service';
import { NoItemsDisclaimerComponent } from '../no-items-disclaimer/no-items-disclaimer.component';
import { LoaderComponent } from '../../account-overview/account-overview/loader/loader.component';
import { EU_DATE_FORMAT, US_DATE_FORMAT } from '../../shared/config/app.config';
import { CommonUtils } from '../../shared/utils/common.utils';

@Component({
  selector: 'app-invoices-list',
  standalone: true,
  imports: [
    AsyncPipe,
    CurrencyPipe,
    I18nModule,
    ReactiveFormsModule,
    NoItemsDisclaimerComponent,
    LoaderComponent,
    DecimalPipe
  ],
  templateUrl: './invoices-list.component.html'
})
export class InvoicesListComponent {
  private readonly translationService = inject(TranslationService);
  private readonly makeAPayment = inject(MakeAPaymentService);

  protected readonly EU_DATE_FORMAT = EU_DATE_FORMAT;
  protected readonly US_DATE_FORMAT = US_DATE_FORMAT;
  protected readonly CommonUtils = CommonUtils;

  paymentList = input<any[]>([]);
  isLoading = input<boolean>(false);
  isCompactView = input<boolean>(false);


  getStatus(date: string): Observable<string> {
    return this.translationService.translate(`makeAPayment.${this.isOpen(date) ? 'open' : 'pastDue'}`);
  }

  isOpen(date: string): boolean {
    const mDate = moment(date, 'DD/MM/YYYY');
    const today = moment().startOf('day');
    const diffInDays = mDate.diff(today, 'days');

    return diffInDays >= 0;
  }

  invoicePdf(invoiceNo): void {
    this.makeAPayment.downloadPdf(invoiceNo);
  }

  isPromptPay(invoice: any): boolean {
    return !!Number.parseFloat(invoice.discAmount);
  }
}
